import {
  addUniqueValueToArray
} from 'utils/redux'

export const NAMESPACE = 'KanBo/Home/users/'
export const REFRESH = NAMESPACE + 'REFRESH'
export const SET_MODE = NAMESPACE + 'SET_MODE'
export const SET_KEYWORD = NAMESPACE + 'SET_KEYWORD'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const SET_CURSOR = NAMESPACE + 'SET_CURSOR'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET_USER = NAMESPACE + 'SET_USER'

const initialState = {
  mode: 'active',
  keyword: '',
  users: [],
  usersById: {},
  cursor: null,
  loading: false,
  loaded: false
}

export const userDefaults = {
  permissionLevel: 0
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case REFRESH:
      return {
        ...initialState,
        mode: state.mode,
        keyword: state.keyword
      }
    case SET_MODE:
      return {
        ...state,
        mode: action.payload.mode
      }
    case SET_KEYWORD:
      return {
        ...state,
        keyword: action.payload.keyword
      }
    case SET_LOAD_STATUS:
      return {
        ...state,
        loading: action.payload.loading,
        loaded: action.payload.loaded
      }
    case SET_CURSOR:
      return {
        ...state,
        cursor: action.payload
      }
    case ADD:
      return {
        ...state,
        users: addUniqueValueToArray({
          array: state.users,
          value: action.payload.data.id,
          index: action.payload.index
        }),
        usersById: {
          ...state.usersById,
          [action.payload.id]: {
            ...userDefaults,
            ...state.usersById[action.payload.id],
            ...action.payload.data
          }
        }
      }
    case ADD_ARRAY: {
      const newState = {
        ...state,
        users: [ ...state.users ],
        usersById: { ...state.usersById }
      }
      action.payload.forEach(user => {
        newState.users = addUniqueValueToArray({
          array: newState.users,
          value: user.id
        })
        newState.usersById[user.id] = {
          ...userDefaults,
          ...newState.usersById[user.id],
          ...user
        }
      })
      return newState
    }
    case REMOVE: {
      const newState = {
        ...state,
        users: [ ...state.users.filter(id => id !== action.payload.id) ],
        usersById: { ...state.usersById }
      }
      delete newState.usersById[action.payload.id]
      return newState
    }
    case SET_USER:
      return state.usersById[action.payload.id] ? {
        ...state,
        usersById: {
          ...state.usersById,
          [action.payload.id]: {
            ...state.usersById[action.payload.id],
            ...action.payload
          }
        }
      } : state
    default: return state
  }
}

export function refresh () {
  return {
    type: REFRESH
  }
}

export function setMode (mode) {
  return {
    type: SET_MODE,
    payload: {
      mode
    }
  }
}

export function setKeyword (keyword) {
  return {
    type: SET_KEYWORD,
    payload: {
      keyword
    }
  }
}

export function setLoadStatus ({ loading, loaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      loading,
      loaded
    }
  }
}

export function setCursor (payload) {
  return {
    type: SET_CURSOR,
    payload
  }
}

export function add ({ data, index }) {
  return {
    type: ADD,
    payload: {
      data,
      index
    }
  }
}

export function addArray (usersArray) {
  return {
    type: ADD_ARRAY,
    payload: usersArray
  }
}

export function remove ({ id }) {
  return {
    type: REMOVE,
    payload: {
      id
    }
  }
}

export function setUser (data) {
  return {
    type: SET_USER,
    payload: data
  }
}
